/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillingownplan3Inputs */

const en_profilebillingownplan3 = /** @type {(inputs: Profilebillingownplan3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Own plan`)
};

const de_profilebillingownplan3 = /** @type {(inputs: Profilebillingownplan3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigener Plan`)
};

/**
* | output |
* | --- |
* | "Own plan" |
*
* @param {Profilebillingownplan3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingownplan3 = /** @type {((inputs?: Profilebillingownplan3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingownplan3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingownplan3(inputs)
	return de_profilebillingownplan3(inputs)
});
export { profilebillingownplan3 as "profileBillingOwnPlan" }